import AppConfig from "AppConfig";
import Button from "components/Button";
import InformationMessage from "components/InformationMessage";
import Title from "components/Title";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import PageLayout from "../../layouts/PageLayout";
import OnboardingSteps from "./components/OnboardingSteps";

const GetConnectedContainer: React.FC = () => {
  const { t } = useTranslation("onboarding");
  const history = useHistory();
  return (
    <PageLayout>
      <OnboardingSteps stage="connect" />
      <Title
        title={t("getConnected.title")}
        data-testid="get-connected"
        className="mb-2"
      />
      <InformationMessage
        text={
          <>
            Connect the provided ethernet cable from an open Ethernet port on
            your ISP modem or other router to the WAN/Internet port of the
            Privacy Hero.
            <br />
            <br />
            Once it is connected, power on the Privacy Hero device by connecting
            the power supply.
            <br />
            <br />
            Wait a minute or so for the router to fully boot up, then click 'I'm
            Connected' below
          </>
        }
      />
      <div
        className="mt-3"
        style={{
          fontSize: "14px",
          color: "#555",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div style={{ paddingBottom: "4px" }}>
          Need help? Check our{" "}
          <a
            href="https://privacyhero.zendesk.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "underline" }}
          >
            FAQ
          </a>
          .
        </div>
        <div>
          Or email us at{" "}
          <a
            href="mailto:support@privacyhero.com"
            style={{ color: "#007bff", textDecoration: "underline" }}
          >
            support@privacyhero.com
          </a>
          .
        </div>
      </div>
      <Button
        className="mt-2"
        onClick={() => history.push("/onboarding/activate")}
      >
        {t("getConnected.ok")}
      </Button>
    </PageLayout>
  );
};
export default GetConnectedContainer;
